<div class="overview-aag" *ngIf="data">
    <div class="aag-location">
        <p *ngIf="data.locationTitle">{{data.locationTitle}}</p>
        <p *ngIf="data.location">{{data.location}}</p>
        <div *ngIf="showLinks" class="links">
            <finder-anchor *ngIf="guestServicesLink"
                [href]="guestServicesLink.url"
                [title]="guestServicesLink.text"
            >{{guestServicesLink.text}}</finder-anchor>
            <ng-container *ngIf="pdfLink">
                <ng-container *ngIf="guestServicesLink" class="hide-mobile"> | </ng-container>
                <finder-anchor
                    [href]="pdfLink.url"
                    [title]="pdfLink.title"
                    target="_blank"
                >
                    <finder-font-icon
                        [htmlEntity]="pdfLink.icon"
                    ></finder-font-icon>
                    {{pdfLink.title}}</finder-anchor>
            </ng-container>
        </div>
    </div>
    <div class="aag-details" *ngIf="data.info">
        <ng-container [ngSwitch]="layout">
            <ng-container *ngSwitchCase="'special'">
                <ng-container *ngTemplateOutlet="special;"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'calendar'">
                <ng-container *ngTemplateOutlet="calendar;"></ng-container>
            </ng-container>
        </ng-container>
        <finder-button *ngIf="hasModal"
            anchor="true"
            (click)="openModal()"
            [title]="data.info.titles.modal"
            [ariaLabel]="data.info.titles.modal">
            {{data.info.titles.modal}}
        </finder-button>
    </div>
</div>
<ng-template #special>
    <p *ngIf="title" class="title">
        {{title}}
    </p>
    <p class="date-range" *ngIf="eventData">
        <time itemprop="startDate" [attr.datetime]="eventData.startDate">
            {{eventData.startDateFormatted}}
        </time> &ndash;
        <time itemprop="endDate" [attr.datetime]="eventData.endDate">
            {{eventData.endDateFormatted}}
        </time>, {{eventData.endYear}}
    </p>
</ng-template>
<ng-template #calendar>
    <p *ngIf="title" class="title">
        {{title}}
    </p>
    <finder-date-picker-wrapper
        [(date)]="date"
        (dateChanged)="onDateChanged($event)">
        <a class="date-text">{{formattedDate}}</a>
    </finder-date-picker-wrapper>
    <finder-loading-spinner *ngIf="!info"></finder-loading-spinner>
    <p *ngIf="info" class="info">{{info}}</p>
</ng-template>
